export const HS_PLUGINS = 'hsPlugins';
export const HS_INPAGE = 'hsInpage';
export const HS_NO_SUBSCRIPTION = 'hsNoSubscriptionLinks';